import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IsbnChangedReportModel} from '../../../models/isbnChangedReport.model';
import {PublicationModel} from '../../../models/publication.model';

@Component({
    selector: 'app-isbn-changed-report-table',
    templateUrl: './isbn-changed-report-table.component.html',
    styleUrls: ['./isbn-changed-report-table.component.scss']
})
export class IsbnChangedReportTableComponent implements OnInit {
    pTable = {
        colNumber: 5,
        expandedRows: {}
    };

    @Input('filtredIsbnChangedReports')
    filtredIsbnChangedReports: IsbnChangedReportModel[] = [];
    selectedIsbnChangedReport: IsbnChangedReportModel = null;
    @Output('onReportSelected')
    onReportSelected = new EventEmitter<IsbnChangedReportModel>();
    @Input() totalItems = 0;

    constructor() {
    }

    ngOnInit() {

    }

    emitModel() {
        this.onReportSelected.emit(this.selectedIsbnChangedReport);

    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/components/generate-report/isbn-changed-report-table/isbn-changed-report-table.component.ts